import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import GetAppIcon from '@mui/icons-material/GetApp';
import PauseIcon from '@mui/icons-material/Pause';
import { Button,Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FormToFilling,styleOptionsProp } from '../../../types/new-form-filling/types';
import { AxymaFooterDiv,Footer,FooterContainer,FooterDiv } from '../../Filling/FormFillingStyle';
import { Paragraph } from '../../Notifications/style/SingleNotificationStyle';

type params = {
  styleOptions: styleOptionsProp,
  checklist: FormToFilling;
  executa: Function,
  isLoading: boolean;
  itemToShow: number,
  setItemToShow: Function,
  onlyOneItem: boolean,
  logado: boolean | null,
  onPause?: () => void,
  onCancel?: () => void,
  isPausing?: boolean,
};

export default function NewFormFillingFooter({
  styleOptions,
  checklist,
  executa,
  isLoading,
  itemToShow,
  setItemToShow,
  onlyOneItem,
  logado,
  onPause,
  onCancel,
  isPausing = false,
}: params) {

  const colorHeader = styleOptions?.colorHeader;

  const { t } = useTranslation();

  const ButtonsComponent = () => {
    return (
      <Stack
        direction="row"
        spacing={1}
        sx={{
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {!onlyOneItem
          && <Button
            startIcon={<ArrowBackIosIcon />}
            className='button is-white'
            variant='contained'
            disabled={itemToShow === 0}
            onClick={() => {
              setItemToShow(itemToShow - 1);
              window.scrollTo(0, 0);
            }}
          >
            {t('formFilling.anterior')}
          </Button>}
        {
          itemToShow + 1 !== checklist?.itens?.length
            ? <Button
              endIcon={< ArrowForwardIosIcon />}
              onClick={() => {
                setItemToShow(itemToShow + 1);
                window.scrollTo(0, 0);
              }}
              className='button is-white'
              variant='contained'>
              {t('formFilling.proximo')}
            </Button>
            : <Button
              color='success'
              endIcon={<GetAppIcon />}
              variant='contained'
              onClick={() => executa()}
              disabled={isLoading}
            >
              {t('formFilling.enviar')}
            </Button>
        }
        {logado && onPause && <Button
          color='warning'
          startIcon={<PauseIcon />}
          variant='contained'
          onClick={onPause}
          disabled={isLoading || isPausing}
        >
          {isPausing ? 'Pausando...' : 'Pausar'}
        </Button>}
        {logado && onCancel && <Button
          color='error'
          variant='outlined'
          onClick={onCancel}
          disabled={isLoading || isPausing}
        >
          Cancelar
        </Button>}
      </Stack>
    );
  };

  return (
    <>
      {logado ?
        <footer className="modal-card-foot">
          <Stack
            width={'100%'}
            direction="column"
            justifyContent="center"
            alignItems="center"
          >
            <ButtonsComponent />
          </Stack>
        </footer>
        : <FooterContainer>
          <Footer
            style={{
              backgroundColor: colorHeader
                ? colorHeader
                : '#643E91'
            }}
          >
            <FooterDiv>
              <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={1}
              >
                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  spacing={1}
                >
                  <ButtonsComponent />
                </Stack>
              </Stack>
              <AxymaFooterDiv>
                <a
                  href={'https://axyma.com.br/'}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Paragraph style={{ textAlign: 'right' }}>Desenvolvido por Axyma&copy;</Paragraph>
                </a>
              </AxymaFooterDiv>
            </FooterDiv>
          </Footer>
        </FooterContainer>}
    </>
  );
}
